import React from "react"
import { Row, Col } from "react-styled-flexboxgrid"

import { TABLE_SIZES } from "./tableSizes"
import Spacer from "~/components/Spacer"
import { USER_INFO_SEARCH_OPTIONS_COMPONENTS } from "../Elements/searchConfig"

const UserInfoRow = () => {
  const ColumnOneComponent = USER_INFO_SEARCH_OPTIONS_COMPONENTS.fullName
  const ColumnTwoComponent = USER_INFO_SEARCH_OPTIONS_COMPONENTS.email
  const ColumnThreeComponent = USER_INFO_SEARCH_OPTIONS_COMPONENTS.phoneNumber
  return (
    <Row>
      <Col {...TABLE_SIZES.fullName}>
        <Spacer mobile={15} desktop={15} />
        <ColumnOneComponent autofocus />
      </Col>
      <Col {...TABLE_SIZES.email}>
        <Spacer mobile={15} desktop={15} />
        <ColumnTwoComponent />
      </Col>
      <Col {...TABLE_SIZES.phoneNumber}>
        <Spacer mobile={15} desktop={15} />
        <ColumnThreeComponent />
      </Col>
      <Col {...TABLE_SIZES.nothing} />
    </Row>
  )
}

export default UserInfoRow
